import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { RegisterForm } from '../components/RegisterForm';
import { useAuth } from '../context';

export function RegisterPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Если пользователь уже авторизован, перенаправляем на dashboard
  React.useEffect(() => {
    if (user) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, navigate]);

  const handleRegisterSuccess = () => {
    // После успешной регистрации перенаправляем на страницу входа
    navigate('/login', { replace: true });
  };

  const handleSwitchToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <RegisterForm 
          onSuccess={handleRegisterSuccess}
          onSwitchToLogin={handleSwitchToLogin}
        />
        
        <div className="mt-6 text-center text-sm text-muted-foreground">
          <Link 
            to="/" 
            className="hover:text-primary transition-colors"
          >
            ← Вернуться на главную
          </Link>
        </div>
      </div>
    </div>
  );
}
